<i class="fa fa-long-arrow-left inicio ml-1" aria-hidden="true"><a routerLink='/inicio' class="text-left inicio">
    Inicio</a></i>
    
<div class="container mt-5 mb-5">

    <div class="row">
        <div class="col-md-12 d-flex justify-content-center">
            <h1 class="text-center" id="atualizar">Atualizar tema</h1>
        </div>
    </div>

    <div class="row d-flex justify-content-center">
        <div class="col-md-6">
            <div class="form-group">
                <label for="descricao">Descrição:</label>
                <input [(ngModel)]='tema.descricao' type="text" class="form-control" id="descricao">
            </div>

            <div class="d-flex justify-content-center">
                <button class="btn btn-danger mr-4" id="botao-cancelar" routerLink='/inicio'>Cancelar</button>
                <button (click)='atualizar()'class="btn" id="botao-atualizar">Atualizar</button>
            </div>
        </div>
    </div>
</div>